export const filterTime = (filter: "passed" | "future") => (time: Date) => {
  const currentDate = new Date();
  const selectedDate = new Date(time);

  return filter === "passed"
    ? currentDate.getTime() < selectedDate.getTime()
    : currentDate.getTime() > selectedDate.getTime();
};
